import { formatNumberWithCommas } from "helpers/format";
import moment from "moment";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const ChartLine = ({
  categories = [],
  series = [],
  className = '',
  title = '',
  enabledDataLabels = false,
  typeFormatDate = 'MM-DD'
}: any) => {

  const { t, i18n } = useTranslation();

  var options = {
    chart: {
      height: 350,
      toolbar: 'false',
      type: 'line',
      // group: 'social',
      zoom: {
        enabled: false
      },

    },
    dataLabels: {
      enabled: enabledDataLabels,


    },
    stroke: {
      curve: 'straight', // straight
      width: [2, 2, 2, 2],
      dashArray: [0, 0, 0, 0]
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6
      }
    },
    xaxis: {
      type: 'category',
      categories: categories,
      labels: {
        show: true,
        formatter: function (val: any) {
          return moment(val).format(typeFormatDate);
        },
        style: {
          fontSize: "12px",
          fontWeight: 500,
          colors: categories?.map((item: any) => (moment(item).days() === 0 ? '#F06548' : (moment(item).days() === 6 ? '#25A0E2' : ''))), // 0 is Sunday , 1 is Monday, ... , 6 is Saturday
        },
        rotate: 0,
      },
      tickAmount: 15
    },
    yaxis: [{
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#008FFB'
      },
      labels: {
        formatter: function (val: any) {
          return formatNumberWithCommas(val);
        },
        style: {
          colors: '#008FFB',
        }
      },
      title: {
        text: title,
        style: {
          color: '#008FFB',
        }
      },
      tooltip: {
        enabled: false
      }
    },
    ],
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val: any) {
              return val
            }
          },
          formatter: function (val: any) {
            return formatNumberWithCommas(val)
          }
        },
        {
          title: {
            formatter: function (val: any) {
              return val
            }
          },
          formatter: function (val: any) {
            return formatNumberWithCommas(val)
          }
        },
        {
          title: {
            formatter: function (val: any) {
              return val
            }
          },
          formatter: function (val: any) {
            return formatNumberWithCommas(val)
          }
        },
        {
          title: {
            formatter: function (val: any) {
              return val
            }
          },
          formatter: function (val: any) {
            return formatNumberWithCommas(val)
          }
        },
      ]
    },
    grid: {
      borderColor: '#f1f1f1',
    },
  };
  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        height="350"
        className={`apex-charts ${className}`}
      />
    </React.Fragment>
  );
};

export default ChartLine;